module.exports = __webpack_public_path__ + "img/horizontal_3_6_pp13_9006.095b8be1.png";